import AudioEngine from '@/webgl/audio/AudioEngine'
import ILoadableAudio, { AudioAsset } from '@/webgl/audio/interfaces/ILoadableAudio'
import AudioResource from '@/webgl/audio/resources/AudioFile'
import AudioSprite from '@/webgl/audio/resources/AudioSprite'
import Signal from '@/webgl/core/Signal'
import ILoadable from '@/webgl/runner/interfaces/ILoadable'

export default class AudioBundle implements ILoadable {
  resources: ILoadableAudio[] = []

  _dependencies: string[] = []
  onLoaded: Signal<AudioBundle> = new Signal()
  loaded: boolean = false

  constructor(readonly engine: AudioEngine) {}

  addSprite(url: string, subtitles: string = null) {
    this.resources.push(new AudioSprite(this.engine, url, subtitles))
  }

  addFile(url: string, subtitles: string = null) {
    this.resources.push(new AudioResource(this.engine, url, subtitles))
  }

  async load(abort: AbortSignal): Promise<void> {
    const promises: Promise<unknown>[] = []
    const results: AudioAsset[] = []

    for (const resource of this.resources) {
      promises.push(resource.load(abort).then((res) => results.push(res)))
    }

    await Promise.all(promises)

    for (const res of results) {
      for (const key in res) {
        this.engine.library.add(key, res[key].source)
        if (res[key].track) this.engine.subtitles.add(key, res[key].track)
        this._dependencies.push(key)
      }
    }

    this.loaded = true
    this.onLoaded.emit(this)
  }

  dispose() {
    for (const key of this._dependencies) {
      const entry = this.engine.library.get(key)
      if (entry) {
        entry.dispose()
        this.engine.library.remove(key)
      }
      if (this.engine.subtitles.has(key)) this.engine.subtitles.remove(key)
    }
    this._dependencies = []
    this.resources = []
    this.onLoaded.release()
  }
}
